import { z } from 'zod';

export const AuthLoginFlow = z.enum(['oauth2']);
export type AuthLoginFlow = z.infer<typeof AuthLoginFlow>;

/** localStorage key for auth data, used by wolt-auth and WebView integration */
export const AUTH_STORAGE_KEY = 'auth-data';

const NAME_AUTH_LOGIN_FLOW = 'authLoginFlow';

export const AUTH_LOGIN_FLOW = AuthLoginFlow.safeParse(
  localStorage.getItem(NAME_AUTH_LOGIN_FLOW)?.toLocaleLowerCase(),
);
